// @flow

export default {
  azul: '#E31E24',
  background: '#f9fafb',
  battleshipGrey: '#6a6d7b',
  blueBlue: '#B8181D',
  bluegreen: '#008b69',
  brownishOrange: '#cd9625',
  charcoalGrey: '#2D2D2D',
  cherry: '#de002e',
  cobalt: '#8B1419',
  coolGrey: '#a8acbb',
  greenBlue: '#00bd83',
  jungleGreen: '#008551',
  lightAquamarine: '#65fbd2',
  lightBlueGrey: '#d7dbe9',
  macaroniAndCheese: '#efc036',
  paleGrey: '#eaecf6',
  paleGreyThree: '#f9fafb',
  paleGreyTwo: '#f6f7fb',
  paleRed: '#d46147',
  rawSienna: '#9c6c00',
  salmon: '#ff8669',
  sapphire: '#B8181D',
  silver: '#d7dbe9',
  turquoise: '#06c19c',
  veryLightBlue: '#fafbff',
  white: '#ffffff',
};
